"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableRowHeader = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useDVL_1 = __importDefault(require("@opsbase/web-dvl/useDVL"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const DVLTableRowCount_1 = __importDefault(require("./DVLTableRowCount"));
const DVLTableRowSelector_1 = __importDefault(require("./DVLTableRowSelector"));
const DVLTableRowTreeLines_1 = __importDefault(require("./DVLTableRowTreeLines"));
const makeMyClasses = (isExpanded, width, color, backgroundColor) => ({
    staticCell: {
        backgroundColor: backgroundColor.main,
        borderLeft: '4px solid ' + (color.main || 'transparent'),
        position: 'sticky',
        left: 0,
        width,
        zIndex: 9,
        minHeight: isExpanded ? 52 : undefined,
    },
    actionCell: {
        padding: '12px 8px 12px 6px',
        minHeight: 48,
        overflow: 'visible',
        display: 'flex',
        alignItems: 'center',
    },
});
function DVLTableRowHeader(props) {
    var _a;
    const { nodeKey, children, item, childrenBelow, backgroundColor = lib_palette_1.default.White, onMouseEnter, onMouseLeave, } = props;
    const dt = (0, useDataTree_1.default)();
    const { disableCounts, selectable } = (0, useDVL_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const node = dt.nodesByKey.get(nodeKey);
    const isSingleItem = !!item;
    const isRoot = node === dt.rootNode;
    const group = isSingleItem ? undefined : node === null || node === void 0 ? void 0 : node.group;
    const color = isSingleItem ? 'transparent' : (group === null || group === void 0 ? void 0 : group.color) || 'transparent';
    const isGrouping = !!((_a = view.groupBys) === null || _a === void 0 ? void 0 : _a.length);
    const isItemCollection = !!node.itemCollection;
    const isSelectable = selectable && isItemCollection;
    const selectionWidth = 24;
    const treeLinesWidth = 34;
    const countsWidth = isGrouping && !disableCounts ? 64 : 0;
    const width = Math.max(view.fields[0].width, 140) +
        (!!view.pinField ? Math.max(view.fields[1].width, 140) : 0) +
        24 -
        selectionWidth +
        countsWidth +
        treeLinesWidth;
    const myCss = (0, web_css_1.default)(makeMyClasses, [node.expanded, width, color, backgroundColor]);
    const selector = (0, react_1.useMemo)(() => {
        return isSelectable ? react_1.default.createElement(DVLTableRowSelector_1.default, { nodeKey: nodeKey, item: item }) : undefined;
    }, [isSelectable, nodeKey, item]);
    const counts = (0, react_1.useMemo)(() => {
        return disableCounts || isSingleItem || isRoot ? undefined : (react_1.default.createElement(DVLTableRowCount_1.default, { nodeKey: nodeKey }));
    }, [disableCounts, isSingleItem, isRoot, nodeKey]);
    const treeLines = (0, react_1.useMemo)(() => {
        return isGrouping ? react_1.default.createElement(DVLTableRowTreeLines_1.default, { nodeKey: nodeKey, item: item }) : undefined;
    }, [isGrouping, nodeKey, item]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: myCss.staticCell + ' rowHeader', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            react_1.default.createElement(Vertical_1.default, null,
                react_1.default.createElement(Horizontal_1.default, null,
                    react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, classes: { root: myCss.actionCell } },
                        selectable && (react_1.default.createElement(Pane_1.default, { style: { minWidth: selectionWidth } }, selector)),
                        react_1.default.createElement(Pane_1.default, { visible: true, style: { minWidth: countsWidth } }, counts)),
                    treeLines,
                    children),
                childrenBelow)));
    }, [
        myCss,
        onMouseEnter,
        onMouseLeave,
        selectable,
        selector,
        countsWidth,
        counts,
        treeLines,
        children,
        childrenBelow,
    ]);
}
exports.DVLTableRowHeader = DVLTableRowHeader;
exports.default = DVLTableRowHeader;
